// extracted by mini-css-extract-plugin
export default {"priority":"cDF2mnY_nwECIQ2mU464","high":"mFVm1ZoXUFqQKN1yPZiv","medium":"rJjEIzRBefq0tbGDC60q","low":"T4LXE_5sxivLWyuR7h_P"};